<template>
  <Radar ref="chartRef" :data="chartData" :options="normalizedOptions" />
</template>

<script setup>
import { computed, ref } from 'vue'
import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js'
import { normalizeChartOptions } from './chartOptions'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

const props = defineProps({
  chartData: { type: Object, required: true },
  options:   { type: Object, default: () => ({}) },
})

const chartRef = ref(null)
const normalizedOptions = computed(() => normalizeChartOptions(props.options))
defineExpose({ get chart() { return chartRef.value?.chart } })
</script>
